import { Flex, Image, Loader, Text } from '@mantine/core'
import Logo from 'assets/logo.png'

const LoaderScreen = ({
    title = "The real productivity gain is not doing more",
    subtitle = "it's doing what matters most",
}) => {
    return (
        <Flex direction={"column"} justify={"center"} align={"center"} h={"100vh"} w={"100vw"} gap={"1.5rem"}>
            <Image src={Logo} alt='logo image' width={250}
                fit='contain' />
            <Flex direction={"column"} justify={"center"} align={"center"} >
                <Text>{title}
                </Text>
                <Text>{subtitle}</Text>
            </Flex>
            <Loader variant='dots' size={"lg"} />
        </Flex>
    )
}

export default LoaderScreen
